import { render } from "./ProcessBpmClientKdp.vue?vue&type=template&id=1f2382d5&scoped=true"
import script from "./ProcessBpmClientKdp.vue?vue&type=script&lang=js"
export * from "./ProcessBpmClientKdp.vue?vue&type=script&lang=js"

import "./ProcessBpmClientKdp.vue?vue&type=style&index=0&id=1f2382d5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2382d5"]])

export default __exports__